function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _empty() {}
function _awaitIgnored(value, direct) {
  if (!direct) {
    return value && value.then ? value.then(_empty) : Promise.resolve();
  }
}
function _invoke(body, then) {
  var result = body();
  if (result && result.then) {
    return result.then(then);
  }
  return then(result);
}
function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }
  if (!value || !value.then) {
    value = Promise.resolve(value);
  }
  return then ? value.then(then) : value;
}
function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }
    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
function _invokeIgnored(body) {
  var result = body();
  if (result && result.then) {
    return result.then(_empty);
  }
}
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { flattenFnArray } from './utils';
import { slotWillBe } from './TransitionManager/TransitionManager';
import { appIdToNameAndSlot } from '../common/utils';
var APP_STATES = {
  loaded: 0,
  bootstrapped: 1,
  mounted: 2,
  unmounted: 3
};
var _wrapperConf = /*#__PURE__*/new WeakMap();
var _appRenderedAtSsr = /*#__PURE__*/new WeakMap();
var _appExtraProps = /*#__PURE__*/new WeakMap();
var _transitionManager = /*#__PURE__*/new WeakMap();
var _appState = /*#__PURE__*/new WeakMap();
var _wrapperState = /*#__PURE__*/new WeakMap();
var _getWrapperProps = /*#__PURE__*/new WeakMap();
var _renderAppFactory = /*#__PURE__*/new WeakMap();
var _getAppProps = /*#__PURE__*/new WeakMap();
var _canonizeCallbacks = /*#__PURE__*/new WeakMap();
var WrapApp = /*#__PURE__*/function () {
  function WrapApp(wrapperConf, ssrOverrideProps, transitionManager) {
    var _this = this;
    _classCallCheck(this, WrapApp);
    _classPrivateFieldInitSpec(this, _wrapperConf, void 0);
    _classPrivateFieldInitSpec(this, _appRenderedAtSsr, false);
    _classPrivateFieldInitSpec(this, _appExtraProps, {});
    _classPrivateFieldInitSpec(this, _transitionManager, void 0);
    _classPrivateFieldInitSpec(this, _appState, 0);
    _classPrivateFieldInitSpec(this, _wrapperState, 0);
    _classPrivateFieldInitSpec(this, _getWrapperProps, function (props) {
      var newProps = Object.assign({}, props);
      newProps.appId = _classPrivateFieldGet(_wrapperConf, _this).appId;
      newProps.getCurrentPathProps = function () {
        return _classPrivateFieldGet(_wrapperConf, _this).props;
      };
      newProps.getWrappedAppProps = function () {
        var _classPrivateFieldGet2;
        return (_classPrivateFieldGet2 = _classPrivateFieldGet(_wrapperConf, _this).wrappedAppConf) === null || _classPrivateFieldGet2 === void 0 ? void 0 : _classPrivateFieldGet2.props;
      };
      newProps.getCurrentBasePath = function () {
        return '/';
      };
      newProps.appWrapperData = {
        appId: _classPrivateFieldGet(_wrapperConf, _this).appId
      };
      return newProps;
    });
    _classPrivateFieldInitSpec(this, _renderAppFactory, function (props, appCallbacks, wrapperCallbacks) {
      return _async(function () {
        var extraProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        _classPrivateFieldSet(_appExtraProps, _this, extraProps);
        var _appIdToNameAndSlot = appIdToNameAndSlot(props.appId),
          slotName = _appIdToNameAndSlot.slotName;
        _classPrivateFieldGet(_transitionManager, _this).handlePageTransition(slotName, slotWillBe.rerendered);
        return _await(wrapperCallbacks.unmount(props), function () {
          return _invoke(function () {
            if (_classPrivateFieldGet(_appState, _this) < APP_STATES.bootstrapped) {
              return _awaitIgnored(appCallbacks.bootstrap(props));
            }
          }, function () {
            return _awaitIgnored(appCallbacks.mount(props));
          });
        });
      });
    });
    _classPrivateFieldInitSpec(this, _getAppProps, function (props) {
      var newProps = Object.assign({}, props);
      newProps.getCurrentPathProps = function () {
        var res = props.getCurrentPathProps();
        return Object.assign({}, res, _classPrivateFieldGet(_appExtraProps, _this));
      };
      return newProps;
    });
    _classPrivateFieldInitSpec(this, _canonizeCallbacks, function (callbacks, wrapPropsWith, appType) {
      var stateMap = {
        bootstrap: APP_STATES.bootstrapped,
        mount: APP_STATES.mounted,
        unmount: APP_STATES.unmounted
      };
      var cbTypes = Object.keys(stateMap);
      return cbTypes.reduce(function (acc, type) {
        if (callbacks[type]) {
          var cb = flattenFnArray(callbacks, type);
          acc[type] = _async(function (props) {
            var wrappedProps = wrapPropsWith(props);
            return _await(cb(wrappedProps), function (res) {
              if (appType === 'wrapper') {
                _classPrivateFieldSet(_wrapperState, _this, stateMap[type]);
              } else {
                _classPrivateFieldSet(_appState, _this, stateMap[type]);
              }
              return res;
            });
          });
        }
        return acc;
      }, {});
    });
    _classPrivateFieldSet(_wrapperConf, this, wrapperConf);
    _classPrivateFieldSet(_transitionManager, this, transitionManager);
    if (ssrOverrideProps) {
      _classPrivateFieldSet(_appExtraProps, this, ssrOverrideProps);
      _classPrivateFieldSet(_appRenderedAtSsr, this, true);
    }
  }
  return _createClass(WrapApp, [{
    key: "wrapWith",
    value: function wrapWith(appCallbacks, wrapperCallbacks) {
      var _this2 = this,
        _this3 = this,
        _this4 = this;
      appCallbacks = _classPrivateFieldGet(_canonizeCallbacks, this).call(this, appCallbacks, _classPrivateFieldGet(_getAppProps, this), 'app');
      wrapperCallbacks = _classPrivateFieldGet(_canonizeCallbacks, this).call(this, wrapperCallbacks, _classPrivateFieldGet(_getWrapperProps, this), 'wrapper');
      var bootstrap = _async(function (props) {
        return _invokeIgnored(function () {
          if (_classPrivateFieldGet(_appRenderedAtSsr, _this2)) {
            return _awaitIgnored(appCallbacks.bootstrap(props));
          } else {
            _classPrivateFieldSet(_appExtraProps, _this2, {});
            return _awaitIgnored(wrapperCallbacks.bootstrap(props));
          }
        });
      });
      var mount = _async(function (props) {
        props.renderApp = _classPrivateFieldGet(_renderAppFactory, _this3).call(_this3, props, appCallbacks, wrapperCallbacks);
        return _invokeIgnored(function () {
          if (_classPrivateFieldGet(_appRenderedAtSsr, _this3)) {
            return _await(appCallbacks.mount(props), function () {
              _classPrivateFieldSet(_appRenderedAtSsr, _this3, false);
            });
          } else {
            return _invoke(function () {
              if (_classPrivateFieldGet(_wrapperState, _this3) < APP_STATES.bootstrapped) {
                return _awaitIgnored(wrapperCallbacks.bootstrap(props));
              }
            }, function () {
              return _awaitIgnored(wrapperCallbacks.mount(props));
            });
          }
        });
      });
      var unmount = _async(function (props) {
        return _invoke(function () {
          if (_classPrivateFieldGet(_appState, _this4) !== APP_STATES.mounted) {
            return _awaitIgnored(wrapperCallbacks.unmount(props));
          } else {
            return _awaitIgnored(appCallbacks.unmount(props));
          }
        }, function () {
          _classPrivateFieldSet(_appExtraProps, _this4, {});
        });
      });
      return {
        bootstrap: bootstrap,
        mount: mount,
        unmount: unmount,
        unload: appCallbacks.unload //TODO: better handling of the "unload" callback for wrapper
      };
    }
  }]);
}();
export { WrapApp as default };